import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

const Guide = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="about">
        <div className="title">SHOPPING GUIDE</div>
        <p>
          The scope of delivery is currently limited to Hong Kong, Macau,
          Mainland China and Taiwan. We do not accept delivery addresses in
          other overseas countries and regions
        </p>
        <p>
          All confirmed orders are not subject to cancellation, refund or
          change.
        </p>
        <p>
          All products can be picked up in store or sent by SF Express. If you
          choose SF Express, the freight is payable on delivery, and customers
          need to pay the relevant freight when receiving the goods (the online
          store system will not charge, and the fee will be displayed as
          free/Free/$0.). You can choose SF Express self-pickup station, smart
          cabinet or direct delivery to residential/company address (please
          refer to SF Express website for freight). Please fill in the delivery
          address information clearly when placing an order.
        </p>
        <p>
          For in-stock products selected for express delivery, we will ship the
          goods within 2 days (excluding weekends and public holidays) after
          confirming the order, and the order will generally be delivered within
          3 to 5 working days. Before the goods are shipped, we will carefully
          check whether there are any faults or damages, and ensure that the
          goods are packed in perfect condition, especially fragile items .
          Customers need to weigh and bear the relevant delivery risks,
          including delays, invalid delivery addresses, damage or loss of goods
          during transportation, and we will not bear any responsibility.
        </p>
        <p>
          For pre-order products that are out of stock, please pay attention to
          the order time listed in the product content. We will notify customers
          and send out the products after they arrive. Some home products only
          list the approximate order time, which may be changed and extended. If
          customers need to know the exact order time, please ask us before
          placing an order. All confirmed orders are not subject to
          cancellation, refund or change.
        </p>
        <p>
          If you place an order with items that have different delivery dates,
          we will ship the items once all items are in stock. If you wish to
          ship the items separately, please place separate orders.
        </p>
        <p>
          Some furniture products that cannot be sent by SF Express will use our
          company's furniture delivery service, which costs HK$500 (only one
          small piece of furniture). If you deliver large or more than two
          pieces of furniture, additional fees will be charged. We will contact
          the customer for the fee after receiving the order . Please contact
          the customer service staff for details of the fee. The furniture
          delivery date is Tuesday (New Territories), Wednesday (Kowloon) and
          Thursday (Hong Kong), from 12 noon to 6 pm. We will confirm the
          delivery time with the customer before shipment. Remote areas (Tung
          Chung, Discovery Bay or Ma Wan, etc.) will be charged an additional
          fee. We will contact the customer for the fee after receiving the
          order. The delivery fee does not include the additional costs incurred
          by installation, carrying stairs and parking lots at the delivery
          location. In this case, the transport staff will charge the relevant
          fees to the consignee. The furniture delivery service is subject to
          terms and conditions. Please contact the customer service staff for
          details.
        </p>
        <p>
          If customers purchase small items and furniture products in the same
          order, the system will default to in-store pickup. We will notify
          customers to pick up the goods in the showroom after all the goods are
          in stock. If customers want to ship separately, please place separate
          orders.
        </p>
        <p>
          Some large furniture (dining tables, sofas, TV cabinets and kitchen
          cabinets, etc.) do not have a website for self-service ordering.
          Please contact us via Facebook Messenger and our customer service
          staff will handle the furniture ordering for you. Customers are
          welcome to visit our showroom directly and purchase furniture.
        </p>
        <p>
          All orders (calculated from the arrival of the goods) must be
          completed within two months (including pickup, delivery or exchange).
          If the deadline is exceeded, the order will be considered abandoned
          and the amount paid will not be refunded. The customer must pay the
          full amount of the goods before the ownership of the goods belongs to
          the customer. If there is a problem or dispute in the credit card
          payment process, the company has the right to collect the relevant
          amount and additional administrative fees. The order time or date
          marked on the product is only a tentative and approximate date. If the
          relevant time or date is delayed, we will not bear any responsibility
          .
        </p>
        <p>
          Orders from Macau, Mainland China and Taiwan will be sent by SF
          Express, and the freight is collectable upon delivery. Customers need
          to pay the freight upon receipt. Customers outside Hong Kong, please
          fill in the delivery address information clearly when placing an order
          and be sure to fill in the email for contact purposes. We will not be
          responsible for invalid delivery addresses, goods damaged or lost
          during delivery. Large furniture does not have overseas delivery.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Guide;
